import React, { useState } from "react";
import api, { formatApiError, formatCurrency } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Tag, CheckCircle, XCircle, X } from "@phosphor-icons/react";

export const couponLabel = (c) => {
  if (!c) return "";
  const amount = c.percent_off ? `${c.percent_off}%` : formatCurrency(c.amount_off || 0);
  const dur = c.duration === "forever" ? "para sempre" : c.duration === "repeating" ? `por ${c.duration_in_months} meses` : "na primeira cobrança";
  return `${amount} de desconto ${dur}`;
};

export const applyCoupon = (price, c) => {
  if (!c || !price) return price;
  if (c.percent_off) return Math.max(0, price * (1 - c.percent_off / 100));
  return Math.max(0, price - (c.amount_off || 0));
};

export function CouponBox({ coupon, onChange }) {
  const [code, setCode] = useState("");
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState(null);

  const validate = async (e) => {
    e?.preventDefault();
    if (!code.trim()) return;
    setChecking(true); setError(null);
    try {
      const r = await api.post("/billing/coupon/validate", { code: code.trim() });
      if (r.data.valid) { onChange(r.data); setCode(""); }
      else { setError(r.data.reason || "Cupom inválido"); onChange(null); }
    } catch (err) { setError(formatApiError(err)); } finally { setChecking(false); }
  };

  return (
    <div className="card-crisp p-5" data-testid="coupon-box">
      <div className="flex items-center gap-2 mb-2">
        <Tag size={18} weight="duotone" className="text-indigo-600" />
        <span className="text-xs uppercase tracking-wider text-slate-500 font-medium">Tem um cupom de desconto?</span>
      </div>
      {coupon ? (
        <div className="flex items-center gap-3 rounded-md bg-emerald-50 border border-emerald-200 p-3" data-testid="coupon-applied">
          <CheckCircle size={20} weight="fill" className="text-emerald-600 shrink-0" />
          <div className="flex-1 text-sm">
            <span className="font-mono-nums font-bold text-emerald-800">{coupon.code}</span>
            <span className="text-emerald-900"> · cupom ativo · {couponLabel(coupon)}</span>
            {coupon.expires_at && <div className="text-xs text-emerald-700">Válido até {new Date(coupon.expires_at).toLocaleDateString("pt-BR")}</div>}
          </div>
          <button onClick={() => onChange(null)} className="text-emerald-700 hover:text-emerald-900" aria-label="Remover cupom" data-testid="coupon-remove"><X size={16} /></button>
        </div>
      ) : (
        <form onSubmit={validate} className="flex gap-2">
          <Input value={code} onChange={(e) => { setCode(e.target.value.toUpperCase()); setError(null); }} placeholder="Ex: PRECIFICADOR" className="font-mono-nums uppercase" data-testid="coupon-input" />
          <Button type="submit" disabled={checking || !code.trim()} variant="outline" data-testid="coupon-apply">{checking ? "Verificando..." : "Aplicar"}</Button>
        </form>
      )}
      {error && <p className="flex items-center gap-1 text-xs text-rose-600 mt-2" data-testid="coupon-error"><XCircle size={14} /> {error}</p>}
      {!coupon && !error && <p className="text-xs text-slate-500 mt-2">O desconto é aplicado automaticamente no pagamento e aparece nos preços abaixo.</p>}
    </div>
  );
}
